import React, { useEffect } from 'react';
import { TableHead } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { CircularProgress } from '@material-ui/core';
import Table from 'components/Table';
import { formatCurrency } from 'utils/currency';
import Router from 'components/Router/Router';
import Store from 'store/store';

const { TableBody, TableRow, TableCell } = Table;
const { useParams } = Router;
const { connect, selectors } = Store;

const useStyles = makeStyles({
  container: {
    margin: '2rem 0'
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    margin: 0
  },
  th: {
    fontWeight: 'bold',
    color: '#2F2F2F'
  },
  tableContainer: {
    margin: '1rem 0',
    backgroundColor: 'white',
    borderRadius: '25px',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

interface Props {
  policyId?: number | null;
  isLoading?: boolean;
  aggregateCostAndChargesTable: any[];
}

const TabularOverview = ({
  policyId,
  isLoading = false,
  aggregateCostAndChargesTable
}: Props) => {
  const { portfolio } = useParams<{ portfolio: string }>();
  const classes = useStyles();

  useEffect(() => {
    // eslint-disable-next-line
  }, [policyId, portfolio]);

  return (
    <div className={classes.container}>
      <h5 className={classes.title}>Tabular overview</h5>
      <div
        className={classes.tableContainer}
        style={{ minHeight: isLoading ? '15rem' : 'unset' }}
      >
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Table.Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.th}>Year</TableCell>
                <TableCell className={classes.th}>Net value</TableCell>
                <TableCell className={classes.th}>Adviser charges</TableCell>
                <TableCell className={classes.th}>
                  Investment management charges
                </TableCell>
                <TableCell className={classes.th}>
                  Product/platform charges
                </TableCell>
                <TableCell className={classes.th}>
                  Cumulative adviser charges
                </TableCell>
                <TableCell className={classes.th}>
                  Cumulative Investment management and product/platforms
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {aggregateCostAndChargesTable.map(
                ({
                  year_no,
                  net_value,
                  advisor_charge,
                  total_fund_charge,
                  cumulative_platform_product_charge,
                  total_cumulative_advisor_charge,
                  total_cumulative_platform_product_charge
                }) => {
                  return (
                    <TableRow key={year_no}>
                      <TableCell>{year_no}</TableCell>
                      <TableCell>{formatCurrency(net_value)}</TableCell>
                      <TableCell>{formatCurrency(advisor_charge)}</TableCell>
                      <TableCell>{formatCurrency(total_fund_charge)}</TableCell>
                      <TableCell>
                        {formatCurrency(cumulative_platform_product_charge)}
                      </TableCell>
                      <TableCell>
                        {formatCurrency(total_cumulative_advisor_charge)}
                      </TableCell>
                      <TableCell>
                        {formatCurrency(
                          total_cumulative_platform_product_charge
                        )}
                      </TableCell>
                    </TableRow>
                  );
                }
              )}
            </TableBody>
          </Table.Table>
        )}
      </div>
    </div>
  );
};

export default connect((state: any) => ({
  aggregateCostAndChargesTable:
    selectors.caseSelectors.aggregateCostAndChargesPolicyTable(state)
}))(TabularOverview);
